interface EmptyStateProps {
  title: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
  icon?: string;
}

export default function EmptyState({
  title,
  description,
  actionLabel,
  onAction,
  icon = "ri-inbox-archive-line",
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-16 md:py-24">
      <div className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-background-100 flex items-center justify-center text-foreground-400">
        <i className={`${icon} text-3xl md:text-4xl`}></i>
      </div>
      <h3 className="mt-5 font-heading text-lg md:text-xl font-bold text-foreground-900">
        {title}
      </h3>
      {description && (
        <p className="mt-2 text-sm text-foreground-500 max-w-md">{description}</p>
      )}
      {actionLabel && onAction && (
        <button
          type="button"
          onClick={onAction}
          className="mt-6 inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-refresh-line"></i>
          {actionLabel}
        </button>
      )}
    </div>
  );
}